import { assocPath, path } from 'rambda'
import Vue from 'vue'
import { optionallyCall } from '@utils/functions'

// TODO: remove once Vue supports optional chaining
// Vue.prototype.$prop = (propName, object) => {
//   if (!object || typeof object[propName] === 'undefined') return undefined

//   return object[propName]
// }

Vue.prototype.$recaptchaToken = async function() {
  return 'none'
}

Vue.prototype.$wrap = (() => {
  const setIsLoading = (vm, loadingKey, value) => {
    if (typeof path(['_props', loadingKey], vm) === 'boolean') {
      vm.$emit(`update:${loadingKey}`, value)
      return
    }

    vm[loadingKey] = value
  }

  return async function(action, options, _successMessage) {
    if (typeof options !== 'object') {
      options = { isLoading: options }
      if (_successMessage) options.successMessage = _successMessage
    }

    const { isLoading, successMessage } = options

    try {
      if (isLoading) setIsLoading(this, isLoading, true)

      const result = await optionallyCall(action)

      if (successMessage) this.$store.dispatch('SUCCESS', successMessage)

      return result
    } catch (error) {
      if (this.setErrorMessage) return this.setErrorMessage(error)

      throw error
    } finally {
      if (isLoading) setIsLoading(this, isLoading, false)
    }
  }
})()

export const $up = function $up(path, value) {
  // TODO: move out binding logic to a new function curryBound
  if (typeof value === 'undefined') {
    return function(value) {
      return $up.bind(this)(path, value)
    }
  }

  const [objectKey, ...propertyPath] = Array.isArray(path)
    ? path
    : path.split('.')

  if (!propertyPath.length) {
    return this.$emit(`update:${objectKey}`, value)
  }

  // join by '.' so index values are converted to Number rambda-side
  this.$emit(
    `update:${objectKey}`,
    assocPath(propertyPath.join('.'), value, this[objectKey]),
  )
}

Vue.prototype.$up = $up

// export const $upMerge = function $up(path, value) {
//   if (typeof value === 'undefined') {
//     return function(value) {
//       return $upMerge.bind(this)(path, value)
//     }
//   }

//   const [objectKey, ...propertyPath] = Array.isArray(path)
//     ? path
//     : path.split('.')

//   if (!propertyPath.length) {
//     return this.$emit(`update:${objectKey}`, value)
//   }

//   // join by '.' so index values are converted to Number rambda-side
//   this.$emit(
//     `update:${objectKey}`,
//     assocPath(propertyPath.join('.'), value, {}),
//   )
// }

// Vue.prototype.$upMerge = $upMerge

// // $upMerge resolution
// export const $merge = function $merge(key, value) {
//   this[key] = mergeDeepWithKeyedArrays(this[key], value)
// }

// Vue.prototype.$merge = $merge

// const mergeDeepWithKeyedArrays = mergeDeepWith((a, b) => {
//   if (Array.isArray(a) && typeof b === 'object' && !Array.isArray(b)) {
//     return Object.values(mergeDeepRight(a, b))
//   }

//   return b
// })
